const VoucherReconciliationStatus = {
  NOT_REQUEST_YET: 1,
  WAIT_FOR_APPROVAL: 2,
  APPROVED: 3,
  REJECTED: 4,
  DELETED: 5,
  PREPARE_FOR_SUBMIT: 6
}
export default VoucherReconciliationStatus
